import { graphql } from "@opensea/graphql"

export const CreateOrdersSummaryFragment = graphql(`
  fragment CreateOrdersSummary on Collection {
    floorPrice {
      pricePerItem {
        usd
      }
    }
    fees {
      totalCreatorFee {
        feeBasisPoints
      }
      openseaFee {
        feeBasisPoints
      }
    }
  }
`)
